<template>
  <div class="mt-4">
    <object :data="src" type="application/pdf" width="100%" height="800px">
      <p>
        Oh no!, something went wrong while loading the PDF. Don't worry, you can
        try refreshing the page or
        <a :href="src" class="underline">
          click here to download the PDF file.
        </a>
      </p>
    </object>
  </div>
</template>

<script>
export default {
  name: "PDFViewer",
  props: {
    src: String,
  },
  data() {
    return {
      currentPage: 1,
      totalPages: null,
      scale: "container-width",
    };
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage += 1;
    },
    previousPage() {
      if (this.currentPage > 1) this.currentPage -= 1;
    },
  },
};
</script>

<style></style>
